import styled from 'styled-components'
import {blueColor, screenS} from '@theme/vars'

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 36px;
  width: 100%;

  @media screen and (max-width: ${screenS}) {
    margin-top: 12px;
  }
`

export const MainInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media screen and (max-width: ${screenS}) {
    flex-direction: column;
  }
`

export const ImagePreviewWrapper = styled.div`
  width: 190px;
  height: 190px;

  & #story-edit-image {
    &:hover {
      cursor: pointer;
      opacity: 1;
    }
    & figure {
      width: 190px;
      height: 190px;

      @media screen and (max-width: 750px) {
        width: 100%;
        height: auto;
      }

      & .story-edit-image-preview {
        width: 190px;
        height: 190px;
        object-fit: cover;
        margin-top: -25px;

        @media screen and (max-width: ${screenS}) {
          width: 100%;
          height: auto;
        }
      }

      & .change-item {
        position: relative;
        opacity: 0.8;
        border-radius: 80%;
        height: 26px;
        width: 26px;
        top: 15px;
        margin-left: 150px;

        &:hover {
          cursor: pointer;
          opacity: 1;
        }

        @media screen and (max-width: 750px) {
          margin-left: calc(100% - 40px);
        }
      }
    }
  }

  @media screen and (max-width: ${screenS}) {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;

    & div {
      width: 100%;
      height: auto;
      aspect-ratio: 16 / 9;
    }
  }
`

export const SimpleFigureWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px dashed ${blueColor};
  margin: 0 auto;

  width: 190px;
  height: 190px;

  &:hover {
    cursor: pointer;
  }
`

export const ImageTooltipWrapper = styled.div`
  text-align: center;
  color: ${blueColor};
  width: 145px;
  height: 42px;
  margin-top: 4px;
`

export const StoryInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 516px;
  width: 100%;
  margin-left: 20px;

  @media screen and (max-width: ${screenS}) {
    margin-left: 0;
    margin-top: 20px;
    max-width: 100%;
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
`

export const DescriptionWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
`

export const SelectRegionWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
`
